import './Price.scss'
import CustomRangeSlider from '../RangeSlider/RangeSlider'
import { t } from 'i18next'

function Price() {
  return (
    <div className="price">
      <p className="priceLabel">{t('price')}</p>
      <CustomRangeSlider
        attribute="Price"
        title="filterDevicePrice"
        idCustom="Device"
        id="Device"
      />
    </div>
  )
}

export default Price
